import React, { useEffect } from "react";
import LoginErrMsg from "../../../login/generic/loginErrMsg";
import InputField from "../../../generic/inputField";
import EdButton from "../../../generic/edButton";
import { Link } from "react-router-dom";
import { emailRegex } from "../../../utils/regex";

export interface VendorLoginFormProps {
  disableForm: boolean; // used to disable/enable form from parent
  errorMsg?: string; // error message that came from api
  onSubmit: () => void; // function to be called on submit
  onRemoveError: () => void; // removes the errorMsg
  loginForm: any;
  setLoginForm: (val: string) => void; //
}

const LoginForm: React.FC<VendorLoginFormProps> = (props) => {
  const [loginFormErr, setLoginFormErr] = React.useState({
    username: "",
    password: "",
  });
  const [showPassword, setShowPassword] = React.useState(false);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    props.onSubmit();
  };

  useEffect(() => {
    if (props.errorMsg) {
      props.onRemoveError();
    }
  }, [props.loginForm]);

  return (
    <div className="login_form loginid_form">
      <form onSubmit={handleSubmit} className="mg-b60">
        <label htmlFor="email" className="inp_lbl mg-b5 ib">
          Email ID
        </label>
        <InputField
          id="email"
          pattern={emailRegex}
          defaultValue={props.loginForm.userName}
          onChange={(username) =>
            props.setLoginForm({ ...props.loginForm, userName: username })
          }
          onBlur={(error) => {
            setLoginFormErr({
              ...loginFormErr,
              username: error.pattern ? "" : "Please enter a valid email",
            });
          }}
          className="login_inp mg-b40"
          placeholder="Eg: example@email.com"
          autoComplete="off"
        />

        <label className="inp_lbl mg-b5 ib">Password</label>
        <InputField
          defaultValue={props.loginForm.password}
          id="password"
          type={showPassword ? "text" : "password"}
          onChange={(password) =>
            props.setLoginForm({ ...props.loginForm, password: password })
          }
          onBlur={() => {}}
          className="login_inp mg-b40 focus"
          placeholder="Eg:5678987"
          //   autoFocus={props.autoFocus}
          suffix={
            <i
              className={`edel-icon-eye${showPassword ? "-cross" : ""} icon`}
              onClick={() => setShowPassword(!showPassword)}
            />
          }
        />

        {/* Show error if any */}
        {props.errorMsg && (
          <LoginErrMsg className="mg-b40">{props.errorMsg}</LoginErrMsg>
        )}

        {/* Disable button if username or password is blank or form is disabled from outside */}
        <EdButton
          value="Proceed"
          btnTyp="primary"
          className="submit_btn"
          disabled={
            props.disableForm ||
            Object.values(loginFormErr).some((error) => error) ||
            Object.values(props.loginForm).some((value) => !value)
          }
        />
      </form>

      <div className="login_frm_btm_txt">
        <p className="mg-b15">
          <Link
            to="/vendor/forgot-password"
            className="ed_button blue-link link_btn"
          >
            Forgot Password?
          </Link>
        </p>
      </div>
    </div>
  );
};

export default LoginForm;
